import { useQuery } from "@tanstack/react-query";
import { Asset } from "../../../../models/Asset";
import { getAssets } from "../../../../repositorie/MESF-frontend-Repositorie";

export const useSearchAssets = () => {
	return useQuery<Asset[], Error>({
		queryKey: ["assets"],
		queryFn: ({ signal }) => getAssets(signal),
	});
};
